module.exports = __webpack_public_path__ + "img/female-avatar.d495c7f0.jpg";